import BaseComponent from '../base.js';

import * as styles from './key.module.scss';

export default class Key extends BaseComponent {
  /**
   * @type {string}
   * @private
   */
  key;

  /**
   * @param {Props<HTMLButtonElement>} props
   * @param {string} char
   */
  constructor(props, char) {
    super({ ...props, elementTag: 'button', classes: [styles.key] });

    this.key = char;

    this.setListeners();
  }

  /**
   * Sets event listeners.
   * @returns {void}
   * @private
   */
  setListeners() {
    this.addListener('mousedown', this.handleMouseDown.bind(this));
    this.addListener('touchstart', this.handleTouchStart.bind(this));
    window.addEventListener('changekeydown', this.handleChangeKey.bind(this));
    window.addEventListener(
      'changeblock',
      this.handleChangeBlockAndFeedback.bind(this)
    );
    window.addEventListener(
      'changefeedback',
      this.handleChangeBlockAndFeedback.bind(this)
    );
  }

  /**
   * Handles changes in keydown state property.
   * @param {CustomEvent<Partial<StateObj>>} e
   * @returns {void}
   * @private
   */
  handleChangeKey(e) {
    const { keydown } = e.detail;

    if (this.key === keydown?.key) this.addClasses(styles.keyActive);
    else this.removeClasses(styles.keyActive);
  }

  /**
   * Handles pressed mouse button.
   * @returns {void}
   * @private
   */
  handleMouseDown() {
    if (this.state.keydown || this.state.block || this.state.feedback) return;

    this.state.keydown = { key: this.key, detail: 'pointer' };

    if (this.state.start) {
      this.state.attempt = [this.key];
    }
  }

  /**
   * Handles screen touch start.
   * @param {Event} e
   * @returns {void}
   * @private
   */
  handleTouchStart(e) {
    e.preventDefault();
    if (this.state.keydown || this.state.block || this.state.feedback) return;

    this.state.keydown = { key: this.key, detail: 'pointer' };

    if (this.state.start) {
      this.state.attempt = [this.key];
    }
  }

  /**
   * Handles changes in the state's block and feedback property.
   * @param {CustomEvent<StateObj>} e
   * @returns {void}
   * @private
   */
  handleChangeBlockAndFeedback(e) {
    const block = e.detail.block || this.state.block;
    const feedback = e.detail.feedback || this.state.feedback;

    if (block || feedback) {
      this.addClasses(styles.keyBlocked);
    } else if (!block && !feedback) {
      this.removeClasses(styles.keyBlocked);
    }
  }

  /**
   * Activates the key hint990.
   * @param {number} delayMs
   * @returns {void}
   */
  activate(delayMs) {
    this.removeClasses(styles.keyBlocked);

    setTimeout(() => {
      this.addClasses(styles.keyBlocked);
    }, delayMs);
  }
}
